import type { ICompileService, IDirective } from "angular";
import { module } from "angular";

import type IInterval from "./IInterval";

export default class RangeResultDirective implements IDirective {
    public tooltipMapper: any;

    public restrict = "A";

    public scope = {
        intervalHeight: "<",
        intervalLength: "<",
        intervals: "<",
        intervalsCount: "<",
        lowResolutionMode: "<",
        tooltipMapper: "<",
    };

    constructor(private readonly $compile: ICompileService) {}

    public link($scope: any, element: JQuery) {
        $scope.intervals = $scope.intervals || [];
        $scope.markerIntervals = $scope.lowResolutionMode ? 4 : 6;
        this.tooltipMapper = $scope.tooltipMapper;

        const intervalsElement = this.createSVG("svg", {
            class: "intervals main-time-period",
            height: `${$scope.intervalHeight}px`,
            preserveAspectRatio: "none",
            viewBox: `0 0 1442 ${$scope.intervalHeight}`,
            width: "100%",
        });

        this.drawIntervals(
            intervalsElement,
            $scope.intervalsCount,
            $scope.intervalHeight,
            $scope.intervalLength,
            $scope.markerIntervals,
            $scope.intervals,
        );

        element[0].append(intervalsElement);

        this.updateIntervals(element, $scope.intervals);

        this.$compile(intervalsElement)($scope);
    }

    private drawIntervals(
        element: SVGElement,
        intervalsCount: number,
        intervalHeight: number,
        intervalLength: number,
        markerInterval: number,
        intervals: IInterval[],
    ) {
        const markerHeight = Math.floor(intervalHeight / 5);
        const largeHourMarkerInterval = intervalsCount / markerInterval;
        const hourMarkerInterval = intervalsCount / 24;

        intervals.forEach((interval) => {
            const rect = this.createSVG("rect", {
                class: "interval",
                height: intervalHeight - markerHeight,
                width: (interval.stop - interval.start + 1) * intervalLength,
                x: interval.start * intervalLength,
                y: markerHeight,
            });

            rect.dataset.number = interval.start.toString();
            rect.setAttribute("tooltip-append-to-body", "true");
            rect.setAttribute("tooltip-placement", "top");
            rect.setAttribute("uib-tooltip", this.tooltipMapper(interval.start));

            element.append(rect);
        });

        for (let i = 0; i < intervalsCount; i++) {
            const showLargeHourMarker = i % largeHourMarkerInterval === 0;
            const showHourMarker = i % hourMarkerInterval === 0;
            const lastMarker = i === intervalsCount - 1;

            if (showHourMarker) {
                const dash = this.createSVG("line", {
                    class: "dash",
                    x1: i * intervalLength,
                    x2: i * intervalLength,
                    y1: markerHeight,
                    y2: intervalHeight,
                });

                element.append(dash);
            }

            if (showLargeHourMarker || lastMarker) {
                const intervalHourMarker = this.createSVG("line", {
                    class: "thick-dash",
                    x1: lastMarker ? (i + 1) * intervalLength : i * intervalLength,
                    x2: lastMarker ? (i + 1) * intervalLength : i * intervalLength,
                    y1: 0,
                    y2: markerHeight,
                });

                element.append(intervalHourMarker);
            }
        }
    }

    private updateIntervals(element: JQuery, intervals: IInterval[]) {
        const intervalElements = element.find(".interval");

        intervalElements.each((index) => {
            const currentElement = intervalElements.eq(index);
            const elementNumber = +currentElement.attr("data-number");
            const currentInterval = intervals.find((interval) => interval.start === elementNumber);

            const onOff = currentInterval.isOn ? "on" : "off";

            currentElement.addClass(` is-${currentInterval.type}-${onOff}`);
        });
    }

    private createSVG(tag: string, attributes: any) {
        const element = document.createElementNS("http://www.w3.org/2000/svg", tag);

        // todo: Rewrite: See lint error below
        // eslint-disable-next-line no-restricted-syntax
        for (const key in attributes) {
            if (attributes.hasOwnProperty(key)) {
                element.setAttribute(key, attributes[key]);
            }
        }

        return element;
    }
}

module("mmGui").directive("irRangeResult", [
    "$compile",
    ($compile: ICompileService) => new RangeResultDirective($compile),
]);
